export const ProjectData = [
    {
        id: 1,
        title: "UWFlow++",
        about: "Built Chrome extension to quickly preview a UWaterloo course descriptions and its UWFlow ratings by hovering over course listing.",
        tag: ["JavaScript", "HTML", "CSS", "JQuery"],
        demo: "https://chrome.google.com/webstore/detail/uwflow%2B%2B-2021/dmbeljjcflfcihlgomllnmeimpdkbkon",
        github: "https://github.com/bobthetitan7/UWFlowPlus",
        image: require('./assets/UWflow++.png').default
    },
    {
        id: 2,
        title: "Image Repository",
        about: "Image repository webapp that allows users to upload their images, search them via keboard or description, along with storage and extraction from Firebase Storage.",
        tag: ["React", "JavaScript", "Firebase", "HTML", "CSS"],
        // demo
        github: "https://github.com/bobthetitan7/image-repository",
        image: require('./assets/Image.png').default
    },
    {
        id: 3,
        title: "Next Word Predictor",
        about: "Categorization Machine learning model that is able to predict the next word from a given text.",
        tag: ["Python", "Tensorflow", "Pandas", "Numpy", "Matplotlib"],
        // demo
        github: "https://github.com/bobthetitan7/NWP_local"
        // image
    }
]